import { render, staticRenderFns } from "./Index-title.vue?vue&type=template&id=8ab8324a&scoped=true"
import script from "./Index-title.vue?vue&type=script&lang=js"
export * from "./Index-title.vue?vue&type=script&lang=js"
import style0 from "./Index-title.vue?vue&type=style&index=0&id=8ab8324a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab8324a",
  null
  
)

export default component.exports